/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type MachinePartType,
    MachinePartTypeFromJSON,
    MachinePartTypeToJSON,
} from '../models/MachinePartType';

export interface CreateMachinePartTypeRequest {
    /**
     * 
     */
    machinePartType: MachinePartType;
}

export interface DeleteMachinePartTypeRequest {
    /**
     * 
     */
    id: string;
}

export interface GetMachinePartTypeRequest {
    /**
     * 
     */
    id: string;
}

export interface UpdateMachinePartTypeRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    machinePartType: MachinePartType;
}

/**
 * 
 */
export class MachinePartTypeControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for createMachinePartType without sending the request
     */
    async createMachinePartTypeRequestOpts(requestParameters: CreateMachinePartTypeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['machinePartType'] == null) {
            throw new runtime.RequiredError(
                'machinePartType',
                'Required parameter "machinePartType" was null or undefined when calling createMachinePartType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/machine-part-types`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MachinePartTypeToJSON(requestParameters['machinePartType']),
        };
    }

    /**
     */
    async createMachinePartTypeRaw(requestParameters: CreateMachinePartTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachinePartType>> {
        const requestOptions = await this.createMachinePartTypeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachinePartTypeFromJSON(jsonValue));
    }

    /**
     */
    async createMachinePartType(requestParameters: CreateMachinePartTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachinePartType> {
        const response = await this.createMachinePartTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteMachinePartType without sending the request
     */
    async deleteMachinePartTypeRequestOpts(requestParameters: DeleteMachinePartTypeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteMachinePartType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machine-part-types/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteMachinePartTypeRaw(requestParameters: DeleteMachinePartTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteMachinePartTypeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteMachinePartType(requestParameters: DeleteMachinePartTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMachinePartTypeRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAllMachinePartTypes without sending the request
     */
    async getAllMachinePartTypesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machine-part-types`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllMachinePartTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MachinePartType>>> {
        const requestOptions = await this.getAllMachinePartTypesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MachinePartTypeFromJSON));
    }

    /**
     */
    async getAllMachinePartTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MachinePartType>> {
        const response = await this.getAllMachinePartTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMachinePartType without sending the request
     */
    async getMachinePartTypeRequestOpts(requestParameters: GetMachinePartTypeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMachinePartType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machine-part-types/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getMachinePartTypeRaw(requestParameters: GetMachinePartTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachinePartType>> {
        const requestOptions = await this.getMachinePartTypeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachinePartTypeFromJSON(jsonValue));
    }

    /**
     */
    async getMachinePartType(requestParameters: GetMachinePartTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachinePartType> {
        const response = await this.getMachinePartTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateMachinePartType without sending the request
     */
    async updateMachinePartTypeRequestOpts(requestParameters: UpdateMachinePartTypeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateMachinePartType().'
            );
        }

        if (requestParameters['machinePartType'] == null) {
            throw new runtime.RequiredError(
                'machinePartType',
                'Required parameter "machinePartType" was null or undefined when calling updateMachinePartType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/machine-part-types/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MachinePartTypeToJSON(requestParameters['machinePartType']),
        };
    }

    /**
     */
    async updateMachinePartTypeRaw(requestParameters: UpdateMachinePartTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachinePartType>> {
        const requestOptions = await this.updateMachinePartTypeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachinePartTypeFromJSON(jsonValue));
    }

    /**
     */
    async updateMachinePartType(requestParameters: UpdateMachinePartTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachinePartType> {
        const response = await this.updateMachinePartTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
